import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export async function fetchUserEmployments(userId: string) {
	const response = await client.users[":userId"].employments.$get({ param: { userId } });
	return responseHandler(response);
}

export function useUserEmployments(userId: string, options: { enabled?: boolean } = {}) {
	/** Query */
	const query = useQuery({
		queryKey: [userId, "employments"],
		queryFn: () => fetchUserEmployments(userId),
		enabled: options.enabled ?? true,
	});

	return query;
}
